import DateFormatter from "../../utils/DateFormatter";

const getCountryISO2 = require("country-iso-3-to-2");

export default class UniversalTransaction {
    constructor(jsonResponse) {
        this.transactionId = jsonResponse["transaction-id"];
        this.transactionType = jsonResponse["transaction-type"];
        this.date = jsonResponse["date"];
        this.amount = jsonResponse["amount"];
        this.vat = jsonResponse["vat"];
        this.fees = jsonResponse["fees"];
        this.destinationAmount = jsonResponse["dest-amount"];
        this.currency = jsonResponse["currency"];
        this.country = jsonResponse["country"];
        this.countryDisplayValue = jsonResponse["country-display-value"];
        this.status = jsonResponse["status"];
        this.paymentReference = jsonResponse["payment-reference"];
        this.collectionPin = jsonResponse["collection-pin"];
        this.firstName = jsonResponse["first-name"];
        this.lastName = jsonResponse["last-name"];

        this.fullName = this.firstName + " " + this.lastName;

        this.displayDestinationAmount = this.currency + " " + this.destinationAmount;

        this.displayDate = DateFormatter.FormatTransactionCardDate(this.date);

        this.beneficiaryCountryISO2 =  getCountryISO2(this.country).toLowerCase()
    }
}